<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="roleId" name="roleId">
                    <a-input v-model:value="form.roleId"/>
                </a-form-item>
            </div>
            <a-input-search placeholder="搜索" @change="onSearchChange"/>
            <a-tree
                    checkable
                    v-model:checkedKeys="checkedKeys"
                    :tree-data="treeData"
                    :expanded-keys="expandedKeys"
                    :auto-expand-parent="autoExpandParent"
                    :selectable="false"
                    @expand="onMenuExpand"
            >
                <template #title="{title}">
                    <span v-if="title.indexOf(searchValue) > -1">
                        {{ title.substr(0, title.indexOf(searchValue)) }}
                        <span class="tc-red">{{ searchValue }}</span>
                        {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
                    </span>
                    <span v-else>{{ title }}</span>
                </template>
            </a-tree>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {convertGetLimitData, convertSetLimitData, convertTreeData, getParentKey} from "@/utils/convertData";
import {sys_role} from "@/api/adminService";

export default {
    name: "LimitModal",
    mixins: [formMixin],
    data() {
        return {
            menuList: [],
            treeData: [],
            expandedKeys: [],
            checkedKeys: [],
            autoExpandParent: true,
            searchValue: '',

            form: {},
            rules: {
                roleId: [dataCheck.required({}),],
                menuIds: [],
            },
            submitUrl: sys_role.setLimit,
        }
    },
    watch: {
        visible(bool) {
            if (bool) {
                this.getTreeData();
            }
        }
    },
    methods: {
        onSearchChange(e) {
            this.searchValue = e.target.value;
            this.expandedKeys = getParentKey({
                val: e.target.value,
                tree: this.menuList,
                titleField: 'menuName',
                keyField: 'menuId'
            });
            this.autoExpandParent = true;
        },
        onMenuExpand(expandedKeys) {
            this.expandedKeys = expandedKeys;
            this.autoExpandParent = false;
        },
        getTreeData() {
            let checkList = [];
            const menuList = this.menuList;
            menuList.forEach(v => {
                if (v.checked) {
                    checkList.push(v.menuId)
                }
            });

            this.treeData = convertTreeData({
                datas: menuList,
                rootValue: '1628606141145972737',
                valueField: 'menuId',
                titleField: 'menuName',
                parentField: 'parentId'
            });

            this.checkedKeys = convertGetLimitData(
                menuList,
                checkList,
                "menuId"
            );
        },
        transformParams(data) {
            let params = Object.assign({}, data);
            params.menuIds = convertSetLimitData(this.menuList, this.checkedKeys, 'menuId').join(',')
            return params;
        },
    },

}
</script>
<style scoped lang="less">
</style>
